import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { ReportsNavigationModel } from "./report-navigation-data-model";

export class ReportsNavigationGridModel extends ReportsNavigationModel { }

export class ReportsNavigationListingModel extends GridModel<ReportsNavigationGridModel> { }


export class ReportsNavigationPostParams extends GridPostParams {
    pageNumber: number = 1;
    pageSize: number = 10;
    search_text: string = '';
    direction: string = '';
    column: string = '';
    maxSize: number = 5;
}